import Vue from 'vue'
import Router from 'vue-router'

let currentRouterObject = null

const { router } = require(`@/config/default-router-object.js`)
currentRouterObject = router

Vue.use(Router)

export default new Router(currentRouterObject)
